/*
 * funnel-sticky-atc.js
 * --------------------
 * Barra de compra fija.
 *
 * No duplica la logica de carrito: reenvia el submit al formulario real de
 * la ficha, asi respeta la variante y la cantidad seleccionadas y hereda el
 * comportamiento de <product-form> (anadir y saltar al checkout).
 *
 * El precio se refleja desde el DOM de la ficha en lugar de recalcularlo,
 * para que siga siendo correcto cuando Dawn repinta la seccion al cambiar
 * de variante, sin depender de sus eventos internos.
 */
if (!customElements.get('funnel-sticky-atc')) {
  customElements.define(
    'funnel-sticky-atc',
    class FunnelStickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-funnel-sticky-button]');
        this.priceTarget = this.querySelector('[data-funnel-sticky-price]');

        this.form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
        this.mainButton = document.querySelector('.product-form__submit');
        this.priceSource = document.querySelector('.product__info-container .price');

        if (!this.form || !this.button) {
          this.remove();
          return;
        }

        document.body.classList.add('funnel-has-sticky-atc');

        this.button.addEventListener('click', this.onClick.bind(this));

        this.syncPrice();
        this.watchPrice();
        this.watchVisibility();
      }

      onClick(event) {
        event.preventDefault();

        if (this.mainButton && this.mainButton.hasAttribute('disabled')) return;

        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      }

      syncPrice() {
        if (!this.priceTarget) return;

        // La seccion se repinta entera al cambiar de variante: hay que
        // volver a localizar el nodo de precio, el anterior ya no existe.
        this.priceSource = document.querySelector('.product__info-container .price');
        if (!this.priceSource) return;

        this.priceTarget.innerHTML = this.priceSource.innerHTML;

        var mainButton = document.querySelector('.product-form__submit');
        if (!mainButton) return;

        this.mainButton = mainButton;
        this.button.disabled = mainButton.hasAttribute('disabled');
      }

      watchPrice() {
        var container = document.querySelector('.product__info-container');
        if (!container || !window.MutationObserver) return;

        var self = this;
        var pending = null;

        this.priceObserver = new MutationObserver(function () {
          if (pending) window.clearTimeout(pending);
          pending = window.setTimeout(function () {
            self.syncPrice();
          }, 60);
        });

        this.priceObserver.observe(container, { childList: true, subtree: true });
      }

      watchVisibility() {
        var anchor = this.mainButton || document.querySelector('.product__info-container');
        if (!anchor) return;

        var self = this;

        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        this.visibilityObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              // Solo se muestra cuando el boton principal ya ha quedado
              // por encima del viewport, nunca por debajo.
              var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              self.classList.toggle('is-visible', scrolledPast);
            });
          },
          { threshold: 0 }
        );

        this.visibilityObserver.observe(anchor);
      }

      disconnectedCallback() {
        if (this.priceObserver) this.priceObserver.disconnect();
        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        document.body.classList.remove('funnel-has-sticky-atc');
      }
    }
  );
}
